/**
 * Hidden road API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Account } from './account';

export interface HiddenRoadPartner {
  id?: number;
  companyName?: string;
  accountId?: number;
  account?: Account;
  canTradeWithCpt?: boolean;
  canReportForCpt?: boolean;
  canCptReportForMe?: boolean;
}
